import { Button } from '@change/ds-core-ui';

import { PaymentMethodIconsWrapper } from '../components/PaymentMethodIconsWrapper';
import { SavedMethodCard } from '../components/SavedMethodCard';

import { useVariant2 } from './hooks/useVariant2';

type Props = {
	setDisplayExperiment: (displayExperiment: boolean) => void;
};

export const Variant2: React.FC<Props> = ({ setDisplayExperiment }) => {
	const {
		data: { savedPaymentMethod },
		actions: { onClickChangePaymentMethod },
	} = useVariant2({ setDisplayExperiment });

	return (
		<div className="flex flex-col gap-5">
			<SavedMethodCard paymentMethod={savedPaymentMethod} />
			<div className="flex flex-col gap-3">
				<Button variant="tertiary" onClick={onClickChangePaymentMethod}>
					Change Payment Method
				</Button>
				<PaymentMethodIconsWrapper />
			</div>
		</div>
	);
};
